module.exports = __webpack_public_path__ + "img/delete.df4034dd.svg";